import { ScoreGoalType } from '../../types'
import { useTranslation } from 'react-i18next'
import { FC } from 'react'
import { TShirtSize } from '../../components/util/types'
import PerText from '../../components/custom_components/Text'
import PerFlexRow from '../../components/custom_components/FlexRow'
import { Control, Controller } from 'react-hook-form'
import { ScoreGridFormFields } from './ScoreGridsStoreState'
import { InputNumber } from 'antd'

type LatestScoreGoalModalRowProps = {
  type: ScoreGoalType
  value?: number
  mb?: TShirtSize
}
export const LatestScoreGoalModalRow: FC<LatestScoreGoalModalRowProps> = ({ type, value, mb }) => {
  const [t] = useTranslation()

  return (
    <PerFlexRow align="middle" justify="space-between" mb={mb}>
      <PerText fontWeight="bold" fontSize="s">
        {t(`ownGrowthView.overview.chart.xAxisScoreType.${type}`)}
      </PerText>
      <PerText fontWeight="bold" fontSize="s">
        {value || '-'}
      </PerText>
    </PerFlexRow>
  )
}

type DraftScoreGoalModalRowProps = {
  type: ScoreGoalType
  control: Control<ScoreGridFormFields, any>
  isEditMode: boolean
  sgValue?: number
  mb?: TShirtSize
}

export const DraftScoreGoalModalRow: FC<DraftScoreGoalModalRowProps> = ({ type, control, mb, isEditMode, sgValue }) => {
  const [t] = useTranslation()

  return (
    <PerFlexRow align="middle" justify="space-between" mb={mb}>
      <PerText fontWeight="bold" fontSize="s">
        {t(`ownGrowthView.overview.chart.xAxisScoreType.${type}`)}
      </PerText>
      {isEditMode ? (
        <Controller
          control={control}
          name={type}
          rules={{
            required: { value: true, message: `${t('formError.generalRequired')}` },
            min: { value: 1, message: `${t('formError.numberInvalid')}` },
            max: { value: 10, message: `${t('formError.numberInvalid')}` },
          }}
          render={({ field: { onChange, value } }) => (
            <InputNumber min={1} max={10} onChange={onChange} value={value || undefined} style={{ width: '75px' }} />
          )}
        />
      ) : (
        <PerText fontWeight="bold" fontSize="s">
          {sgValue || '-'}
        </PerText>
      )}
    </PerFlexRow>
  )
}
